import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import {
  SchoolLookUpSiteData,
  NetSuiteAsset,
  AssignNetSuiteAssetRequest,
} from 'types'
import { updatedContractLineAsset } from 'store/contractLineAssetManager/operations'

interface UseAssignmentProps {
  schoolData: SchoolLookUpSiteData
  email: string
  netSuiteAsset: NetSuiteAsset
  clearSelectedAsset: () => void
  onAssignmentSuccess?: () => void
}

export const useAssignment = ({
  schoolData,
  email,
  netSuiteAsset,
  clearSelectedAsset,
  onAssignmentSuccess,
}: UseAssignmentProps) => {
  const dispatch = useDispatch()

  const assignSchoolAndAdmin = useCallback(async () => {
    const schoolName = schoolData.netsuiteCustomerId
      ? schoolData.companyName
      : schoolData.organizationName

    const assignmentRequest: AssignNetSuiteAssetRequest = {
      adminToAssign: email,
      city: schoolData.city,
      country: schoolData.country,
      siteName: schoolName,
      region: schoolData.region,
      isTosConfirmed: true, // Assuming TOS is confirmed for assignment
      netSuiteAssetId: netSuiteAsset.id,
      nsCustomerId: schoolData.nsCustomerId,
    }

    try {
      await dispatch(
        updatedContractLineAsset(netSuiteAsset.id, assignmentRequest),
      )

      // Call the success callback to refresh the contract line data
      if (onAssignmentSuccess) {
        onAssignmentSuccess()
      }
    } catch {
      // Error handling is done in the operation
    } finally {
      // Always clear the selected asset to close the modal, regardless of success/failure
      clearSelectedAsset()
    }
  }, [
    email,
    schoolData,
    netSuiteAsset,
    dispatch,
    clearSelectedAsset,
    onAssignmentSuccess,
  ])

  return {
    assignSchoolAndAdmin,
  }
}
